<template>
  <master-layout :enable-scroll-event="true" no-bottom-pad>
    <!-- pb inside the bg-grey-5 root so the nav-pill clearance keeps the page background -->
    <div class="mx-auto md:w-3/4 lg:w-1/2 min-h-screen bg-grey-5 pb-28 lg:pb-0">
      <BackButton
        variant="inline"
        :is-gic="true"
        data-test-id="gensapp-announcements-page-back"
        @click="$router.push('/gic/home')"
      />

      <section class="mx-[24px] md:mx-[32px] lg:ml-[56px] font-aktiv-grotesk font-bold">
        <h4 class="text-[24px] leading-[32px] mb-[4px] text-black md:mb-[32px]">
          {{ $t('copy.announcementPageGIC.title') }}
        </h4>
      </section>

      <section>
        <AnncCard
          v-for="annc in announcements"
          :id="`card${annc.id}`"
          :key="annc.id"
          :annc="annc"
          :status="annc.isNew"
          :data-test-id="'gensapp-announcements-page-annc-id-' + annc.id"
          class="anchor-scroll-margin"
        ></AnncCard>
      </section>
      <div class="my-8 md:my-10 lg:my-12"></div>
    </div>
  </master-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import AnncCard from '@/components/AnncPage/AnncCard';
import BackButton from '@/components/common/BackButton.vue';
import platformMixin from '@/mixins/platformMixin';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';

export default {
  name: 'AnnouncementPage',
  mixins: [platformMixin],
  components: { AnncCard, BackButton },
  computed: {
    ...mapGetters('profile', ['type']),
    ...mapGetters('cms', ['getAnnouncements']),
    announcements() {
      return this.getAnnouncements('GIC');
    },
  },
  async ionViewWillEnter() {
    await this.$store.dispatch('cms/fetchAnnouncements', {
      locale: 'en',
      conferenceType: 'GIC',
      force: true,
    });
    this.$nextTick(() => {
      if (this.$route.hash) {
        const el = document.querySelector(this.$route.hash);
        el && el.scrollIntoView({ behavior: 'smooth' });
      }
    });
    FirebaseAnalytics.setScreenName({
      screenName: 'announcements',
      nameOverride: 'AnnouncementsPage',
    });
  },
  ionViewDidLeave() {
    this.$store.dispatch('announcements/markReadAndRefetch', { conferenceType: 'GIC' });
  },
};
</script>

<style scoped>
section :deep(.tracking-wide a) {
  color: theme('colors.orange') !important;
}
</style>
